import { UPLOAD_TYPE, uploadFile } from 'Api/endpoints/Upload';
import { useError } from 'Api/hooks/useError';
import { useState } from 'react';

export const useFileUpload = pageDown => {
  const [loadingItems, setLoadingItems] = useState([]);
  const { showErrorPopup } = useError();

  const generateId = () => `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const removeLoadingItem = id => {
    setLoadingItems(prev => prev.filter(item => item.id !== id));
  };

  const startUpload = async file => {
    const id = generateId();
    const abortController = new AbortController();

    // 로딩 항목 추가
    const newItem = {
      id,
      filename: file.name,
      abortController,
      startTime: Date.now(),
      total: 0,
      loaded: 0,
    };

    setLoadingItems(prev => [...prev, newItem]);
    pageDown();

    // 업로드 실행
    try {
      const result = await uploadFile(
        UPLOAD_TYPE.CUSTOMER_SUPPORT_CHAT,
        file,
        progress => {
          // 진행률 업데이트
          setLoadingItems(prev => prev.map(item => (item.id === id ? { ...item, loaded: progress.loaded, total: progress.total } : item)));
        },
        abortController.signal
      );

      // 성공 시 제거
      removeLoadingItem(id);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      return result.originPath;
    } catch (error) {
      // 실패 시 제거
      removeLoadingItem(id);
      throw error;
    }
  };

  const cancelUpload = id => {
    const item = loadingItems.find(item => item.id === id);
    if (item) {
      item.abortController.abort();
      removeLoadingItem(id);
    }
  };

  return {
    loadingItems,
    startUpload,
    cancelUpload,
  };
};
